import type { Domain } from '@common/types/domain.type';
import type { DomainsState } from './domains.reducer';
import type { WebsiteState } from '../website-feature.reducer';

import { createSelector } from '@ngrx/store';

import { WEBSITE_DOMAINS_FEATURE_KEY } from './domains.reducer';
import { websiteState } from '../website-state.selectors';

export const selectDomainsState = createSelector(
    websiteState,
    (state: WebsiteState): DomainsState => state[WEBSITE_DOMAINS_FEATURE_KEY]
);

export const selectDomains = createSelector(selectDomainsState, (state: DomainsState): Domain[] => state?.domains);
